var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styles from './DropdownContainer.module.scss';
var DropdownContainer = function (_a) {
    var children = _a.children, className = _a.className, id = _a.id, dataId = _a.dataId;
    return (_jsx("div", __assign({ id: id, className: "".concat(styles.DropdownContainer, " ").concat(className ? className : ''), "data-testid": dataId }, { children: children })));
};
DropdownContainer.propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    dataId: PropTypes.string,
};
export { DropdownContainer };
//# sourceMappingURL=DropdownContainer.js.map